import _construct from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/construct.js";
import { StytchUIClient } from '@stytch/vanilla-js';

var cannotInvokeMethodOnServerError = function cannotInvokeMethodOnServerError(path) {
  return "[Stytch] Invalid serverside function call to ".concat(path, ".\nThe Stytch Javascript SDK is intended to ony be used on the client side.\nMake sure to wrap your API calls in a hook to ensure they are executed on the client.\n```\nconst myComponent = () => {\n  const stytch = useStytch();\n  // This will error out on the server.\n  stytch.magicLinks.authenticate(...);\n  useEffect(() => {\n    // This will work well\n    stytch.magicLinks.authenticate(...);\n  }, []);\n}\n```\n\nIf you want to make API calls from server environments, please use the Stytch Node Library\nhttps://www.npmjs.com/package/stytch.\n");
};

var SSRStubKey = Symbol('__stytch_SSRStubKey'); // eslint-disable-next-line @typescript-eslint/no-explicit-any

var createProxy = function createProxy(path) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  var noop = function noop() {};

  return new Proxy(noop, {
    get: function get(target, p) {
      if (p === SSRStubKey) {
        return true;
      }

      return createProxy(path + '.' + String(p));
    },
    apply: function apply() {
      throw new Error(cannotInvokeMethodOnServerError(path));
    }
  });
};

var createStytchSSRProxy = function createStytchSSRProxy() {
  return createProxy('stytch');
};
/**
 * Creates a Stytch UI client object to call the Stytch APIs and render Stytch UI components.
 * The Stytch client is not available serverside.
 * If you do not use Stytch UI components, use {@link createStytchHeadlessClient} to reduce your bundle size.
 * @example
 * const stytch = createStytchUIClient('public-token-<find yours in the stytch dashboard>')
 *
 * return (
 *   <StytchProvider stytch={stytch}>
 *     <App />
 *   </StytchProvider>
 * )
 * @returns A {@link StytchUIClient}
 */


var createStytchUIClient = function createStytchUIClient() {
  if (typeof window === 'undefined') {
    return createStytchSSRProxy();
  }

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(StytchUIClient, args);
};

export { createStytchUIClient };